import { Option, TranslateHook } from 'interfaces'

export const optionsString = (options: Option[], t: TranslateHook) => {
  return options
    .filter((option) => option.selected)
    .map((option) => t(option.name))
    .join(', ')
}
